import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaPageView } from '../lib/metaPixel';

const SAFE_FUNNEL_PATHS = new Set([
  '/sign-in',
  '/sign-up',
  '/forgot-password',
  '/start-free-trial',
  '/membership-success',
  '/dashboard',
]);

export const MetaPixelTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (SAFE_FUNNEL_PATHS.has(pathname)) trackMetaPageView(pathname);
  }, [pathname]);
  return null;
};
